<template>
<span data-component-name="tooltip-wrapper"
  ref="el"
  class="tooltip-wrapper el-text--ellipsis"
  data-testid="wrapper"
  @mouseenter.once="onMouseEnter"
>
  <el-tooltip
    :disabled="!displayTooltip"
    :content="tooltipText"
    data-testid="tooltip"
    :enterable="enterable"
    placement="top"
    :max-width="tooltipWidth"
  >
    <span
      ref="inner"
      class="tooltip-wrapper-inner"
    >
      <slot />
    </span>
  </el-tooltip>
</span>
</template>

<script lang="ts">
  import { ref, defineComponent } from 'vue';

  export default defineComponent({
    name: 'TooltipWrapper',
    props: {
      enterable: {
        type: Boolean,
        default: true
      },
      tooltipText: {
        type: [String, Number]
      },
      tooltipWidth: {
        type: Number
      },
      disabled: Boolean
    },
    setup(props) {
      const displayTooltip = ref(false);
      const inner = ref<HTMLElement | null>(null);

      function onMouseEnter() {
        if (!props.tooltipText || props.disabled) {
          displayTooltip.value = false;
          return;
        }

        const clientWidth = inner.value?.clientWidth ?? 0;
        const scrollWidth = inner.value?.scrollWidth ?? 0;

        displayTooltip.value = clientWidth < scrollWidth;
      }

      return {
        inner,
        displayTooltip,
        onMouseEnter
      };
    }
  });
</script>

<style lang="scss">
  .tooltip-wrapper {
    display: inline-block;
    vertical-align: middle;
  }

  .tooltip-wrapper-inner {
    overflow-x: hidden;
    text-overflow: ellipsis;
    display: block;
  }
</style>
